export default {
  SET_MODULE: 'SET_MODULE',
  SET_ALL_MODULES: 'SET_ALL_MODULES',
};
